import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { ICON_CANCEL, ICON_SEARCH, ICON_CHECK } from '../extras/icons';
import { ErrorMessage } from '../extras/toastMessages';
import clienteAxios from '../../config/axiosLawyers';
import LawyerRow from './lawyers/LawyerRow';
import { useRef } from 'react';
//Función principal
const LawyerSearchForm = props => {
    //Tomo los props
    const { show, handleClose, particulars, setParticulars, hideModal } = props;
    //Inicializo los ref
    const refText = useRef();
    //Inicializo el state local
    const [text, setText] = useState('');
    const [loading, setLoading] = useState(false);
    const [lawyers, setLawyers] = useState(null);
    //Manejo el cambio
    const handleChange = e => {
        setText(e.target.value);
    }
    //Manejo la búsqueda
    const handleSearch = async e => {
        //Invalido por defecto
        e.preventDefault();
        e.stopPropagation();
        //Valido
        if(!text || text.trim().length < 3){
            //Mensaje
            ErrorMessage('Debe indicar al menos 3 caracteres');
            //Foco
            refText.current.focus();
            //Cancelo operación
            return false;
        }
        //Continúo
        try{
            //Pongo espera
            setLoading(true);
            //Consulta
            const response = await clienteAxios.get(`/abogado/${text}`);
            //Asigno los datos
            setLawyers(response.data);
            //Oculto espera
            setLoading(false);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto espera
            setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Manejo la selección
    const handleSelect = selected => {
        let added = false;
        //Verifico que no está agregado
        particulars.map(p => {
            if(p.index === selected.id){
                added = true;
                return false;
            }
        });
        //Me fijo si está agregado
        if(!added){
            //Armo los datos
            const data = {
                index: selected.id,
                matricula: selected.matricula.substring(1),
                cuit: selected.cuit,
                domicilio: selected.domicilio,
                email: selected.email,
                telefono: selected.telefono,
                persona: {
                    apellido: selected.apellido,
                    nombre: selected.nombre,
                    tipo_documento: 'CUIT',
                    nro_documento: selected.cuit
                }
            }
            //Seteo los particulars
            setParticulars([
                ...particulars,
                data
            ]);
            //Cierro la ventana
            handleClose();
        }
    }
    //Manejo evento de apertura
    const handleOnShow = () => {
        //Oculto el modal anterior
        hideModal(true);
        //Pongo el foco
        refText.current.focus();
    }
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            scrollable
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Buscar Abogado
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSearch} autoComplete="off">
                    <div className="row">
                        <div className="col-md-10">
                            <div className="form-group">
                                <Form.Control
                                    id="texto"
                                    className="form-control" 
                                    name="texto" 
                                    type="text" 
                                    value={ text }
                                    onChange={handleChange}
                                    disabled={ loading }
                                    placeholder="Ingrese apellido, matrícula y/o cuit"
                                    ref={refText}
                                />
                            </div>
                        </div>
                        <div className="col-md-1">
                            <div className="form-group">
                                <Button variant="primary" className="text-center" type="submit" disabled={loading}>
                                    <ICON_SEARCH />
                                </Button>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {
                                loading ? (
                                    <Spinner animation="border" />
                                ) : null
                            }
                            {
                                lawyers ? (
                                    <table className="table table-sm table-hover" style={{ maxHeight: '200px' }}>
                                        <thead>
                                            <tr>
                                                <th colSpan="2">Resultados de la búsqueda ({lawyers.length})</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{maxHeight: '200px', overflowY: 'auto'}}>
                                            {
                                                lawyers.map(lawyer => (
                                                    <LawyerRow
                                                        key={`lsfl${lawyer.id}`}
                                                        lawyer={lawyer}
                                                        handleSelect={handleSelect}
                                                    />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                ) : null
                            }
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LawyerSearchForm;